module.exports = "https://web-assets.ifttt.com/packs/media/fonts/avenir_next-demi-0667ef4e.ttf";